export default "/_next/static/chunks/fonts/HK Grotesk Extra Bold-28acfbf3360bd364cf2b202881426047.otf";